/*
 * Phiên đăng nhập của học viên (gateway dùng chung api.sutucon.com).
 * loading = đang hỏi; user = null khi chưa đăng nhập — hai trạng thái khác nhau
 * để không chớp màn hình đăng nhập trong lúc chờ.
 */
import { createContext, useContext, useEffect, useState, type ReactNode } from "react"
import { api } from "@/lib/api"

type SessionState = { loading: boolean; user: any }
const SessionContext = createContext<SessionState>({ loading: true, user: null })

export function SessionProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SessionState>({ loading: true, user: null })
  useEffect(() => {
    api("/api/session")
      .then(({ user }) => setState({ loading: false, user }))
      .catch(() => setState({ loading: false, user: null }))
  }, [])
  return <SessionContext.Provider value={state}>{children}</SessionContext.Provider>
}

export const useSession = () => useContext(SessionContext)
